import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { adminLayout } from '../../../theme/foundations/adminPanel';

/** Pie discreto del panel administrativo: copyright + rótulo del panel. */
export default function AdminFooter() {
  const year = new Date().getFullYear();

  return (
    <Flex
      as="footer"
      align="center"
      justify="space-between"
      flexWrap="wrap"
      gap={2}
      px={{ base: adminLayout.contentPaddingMobile, lg: adminLayout.contentPadding }}
      py={4}
      borderTop="1px solid"
      borderColor="adminPanel.cardBorder"
      color="adminPanel.textMuted"
      fontSize="xs"
    >
      <Text>© {year} SIESA. Todos los derechos reservados.</Text>
      <Text>Panel administrativo</Text>
    </Flex>
  );
}
